var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DES_EVO_TENANT_TOKEN, DES_EVO_USER_TOKEN, getConfig } from "@jti/fe-common";
import { sanitizeBaseUrl } from "../../utils";
import { Rest } from "../Rest";
// TODO : Implement the SurveyApi methods as EVO client once it is available
export class SurveyApi extends Rest {
    constructor(baseUrl, tenantToken, recaptchaId) {
        super(sanitizeBaseUrl(baseUrl));
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.setCommonHeader(DES_EVO_TENANT_TOKEN, tenantToken);
    }
    static init() {
        if (!SurveyApi.instance) {
            const _a = getConfig(), { EVO_DOMAIN, EVO_TENANT } = _a, config = __rest(_a, ["EVO_DOMAIN", "EVO_TENANT"]);
            SurveyApi.instance = new SurveyApi(EVO_DOMAIN, EVO_TENANT, config["X-RECAPTCHA-ID"]);
        }
        return SurveyApi.instance;
    }
    getAvailableSurveys(userUuid, ciamToken) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const { data } = yield this.request(`/api/loyalty/consumers/${userUuid}/surveys`, {
                method: "GET",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciamToken,
                },
            });
            return (_a = data === null || data === void 0 ? void 0 : data.surveys) !== null && _a !== void 0 ? _a : [];
        });
    }
    getSurveyStatus(userUuid, ciamToken, surveyId) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.request(`/api/loyalty/consumers/${userUuid}/survey/${surveyId}/status`, {
                method: "GET",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciamToken,
                },
            }, true);
            return data === null || data === void 0 ? void 0 : data.status;
        });
    }
    startSurvey(userUuid, ciamToken, surveyId, userInputCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const { statusCode } = yield this.request(`/api/loyalty/consumers/${userUuid}/survey/${surveyId}/start`, {
                method: "POST",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciamToken,
                },
                body: JSON.stringify({
                    serial_code: userInputCode,
                }),
            });
            return { statusCode };
        });
    }
    validateSurveySerialCode(userUuid, ciamToken, surveyId, userInputCode) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.request(`/api/loyalty/consumers/${userUuid}/survey/${surveyId}/validate`, {
                method: "POST",
                headers: {
                    [DES_EVO_USER_TOKEN]: ciamToken,
                },
                body: JSON.stringify({
                    serial_code: userInputCode,
                }),
            });
        });
    }
}
//# sourceMappingURL=SurveyApi.js.map